import { memo } from 'react';
import { setComma } from '@wconcept/wconcept-common/utils/commonUtils';
import Checkbox from '@wconcept/wconcept-ui-renewal/components/atoms/Checkbox';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import * as S from './style';

interface IProps {
  name?: string;
  cnt?: number | string;
  value?: number | string;
  checked?: boolean;
  suffix?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FltChkItem = ({
  name,
  cnt,
  value,
  checked,
  suffix,
  onChange,
}: IProps) => (
  <S.FltChkItem className="filter-chk item">
    <Checkbox value={value} checked={checked} onChange={onChange}>
      <Text className="txt">{name}</Text>
      {cnt != null && <Text className="cnt">{setComma(String(cnt))}</Text>}
      {suffix && suffix}
    </Checkbox>
  </S.FltChkItem>
);

export default memo(FltChkItem);
